let numeral = require('numeral');

export default function(h, row, index) {
    let _s1 = window.numeral(row.summa_full+0).format('0,0. ₽');
    let _s2 = window.numeral(row.summa_discount+0).format('0,0. ₽');
    let _s3 = window.numeral(row.summa_full+0-row.summa_discount).format('0,0. ₽');

    return <span><span class="vouchers_table__full_summ">{_s1}</span><br /><span class="vouchers_table__summa_discount">{_s2}</span><br/><span class="vouchers_table__summa_to_pay">{_s3}</span></span>
}
